
//ProductCategory
const VSTS_CATEGORY = 1;
const VSTT_CATEGORY = 2;
const OTHER_CATEGORY = 3;

//VSTT Extended Option
const ISSUE_TEST_MERCHANT = "ITM";
const ACQUIRER_TEST_ACS = "ATA";

//Product ID
const VSTS_PRODUCT = 1;
const TEST_MERCHANT_PROD_PRODUCT = 2;
const TEST_ACS_PROD_PRODUCT = 3;
const TEST_MERCHANT_PRE_PROD_PRODUCT = 4;
const TEST_ACS_PRE_PROD_PRODUCT = 5;

//Product Info ID
const BASE_SUBSCRIPTION = 1;
const EXTENSION_SUBSCRIPTION = 2;
const VSTT_SETUP = 3;
const MONTHLY_MERCHANT = 4;
const ANNUAL_MERCHANT = 5;
const MONTHLY_ACS = 6;
const ANNUAL_ACS = 7;

//Recurring Interval Type
const MONTHLY_SUBSCRIPTION_INTERVAL = 1;
const YEARLY_SUBSCRIPTION_INTERVAL = 2;

//For other Testing Only. Not used yet
const ACS_SETUP = 'E'
const THREE_DS_SERVER_SETUP = 'F'

const PRODUCTION_ONLY = 'P';
const PRE_PRODUCTION_ONLY = 'Q';
const BOTH_ENV = "R"


const handleEnvironmentSelected = (value,setEnvironmentFunction) => {
    if (value == PRODUCTION_ONLY) {
        setEnvironmentFunction({ production: true, preProduction: false })
    }
    else if (value == PRE_PRODUCTION_ONLY) {
        setEnvironmentFunction({ production: false, preProduction: true })
    }

    else if (value == BOTH_ENV) {
        setEnvironmentFunction({ production: true, preProduction: true })
    }

    else {
        alert("Invalid value");
    }

}

const handleCheckboxListSelected = (event,selectedList,setSelectedList) => {
    const index = selectedList.values.findIndex(v => v === event.target.value);
    if (index !== -1) {
        return setSelectedList({
            values: [...selectedList.values.slice(0, index), ...selectedList.values.slice(index + 1)]
        });
    }
    return setSelectedList({
        values: [...selectedList.values, event.target.value]
    });
}


export const ProductSelectionLogic = {
    handleEnvironmentSelected,
    handleCheckboxListSelected
}

export const ProductSelectionConst={
    VSTS_CATEGORY,
    VSTT_CATEGORY,
    OTHER_CATEGORY,

    ISSUE_TEST_MERCHANT,
    ACQUIRER_TEST_ACS,

    VSTS_PRODUCT,
    TEST_MERCHANT_PROD_PRODUCT,
    TEST_ACS_PROD_PRODUCT,
    TEST_MERCHANT_PRE_PROD_PRODUCT,
    TEST_ACS_PRE_PROD_PRODUCT,

    BASE_SUBSCRIPTION,
    EXTENSION_SUBSCRIPTION,
    VSTT_SETUP,
    MONTHLY_MERCHANT,
    ANNUAL_MERCHANT,
    MONTHLY_ACS,
    ANNUAL_ACS,

    ACS_SETUP,
    THREE_DS_SERVER_SETUP,

    PRODUCTION_ONLY,
    PRE_PRODUCTION_ONLY,
    BOTH_ENV,

    MONTHLY_SUBSCRIPTION_INTERVAL,
    YEARLY_SUBSCRIPTION_INTERVAL
}